<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Difficulty Level</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
            </v-toolbar>
            <v-data-table :headers="headers" :items="difficulty_level_list" class="elevation-1 mytable" dense
                :search="search">
                <template v-slot:top>
                    <v-toolbar flat dense color="white">
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                        </v-text-field>
                        <span style="width: 20px"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="button" v-on="on">Add Difficulty Level</v-btn>
                            </template>
                            <v-card>
                                <v-card-title class="toolbar">
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>

                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <v-text-field v-model="addedItem.quiz_difficulty_Level" dense rounded
                                                    outlined persistent-hint :hint="editedIndex == -1
            ? 'For example :: Easy, Moderate, Difficult'
            : ''
            " label="Difficulty Level"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <v-text-field v-model="editedItem.quiz_difficulty_Level" dense rounded
                                                    outlined persistent-hint :hint="editedIndex == -1
            ? 'For example :: Easy, Moderate, Difficult'
            : ''
            " label="Difficulty Level"></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                    label="Active"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="button" @click="close">Cancel</v-btn>
                                    <v-btn class="button" @click="save">Save</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>
                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>

                    </div>
                </template>
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        overlay: false,
        errorMsg: {
            quiz_difficulty_Level: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        // extraBreadcrumbItems: [
        //     { text: "Difficulty Level Master", disabled: true, href: "" },

        // ],
        // breadcrumbClass: "breadcrumb-style1",

        dialog: false,
        headers: [
            {
                text: "Difficulty Level",
                align: "left",
                sortable: false,
                value: "quiz_difficulty_Level",
            },
            {
                text: "Active",
                align: "left",
                sortable: true,
                value: "isactive",
            },
            { text: "Actions", value: "action", sortable: false },
        ],
        difficulty_level_list: [],
        editedIndex: -1,
        addedItem: {
            quiz_difficulty_Level: null,
        },
        editedItem: {
            id: "",
            quiz_difficulty_Level: "",
            isactive: true,
        },
        defaultItem: {
            id: "",
            quiz_difficulty_Level: "",
            isactive: true,
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1
                ? "New Difficulty Level"
                : "Edit Difficulty Level";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        initializeErrorMsgFalse() {
            this.errorMsg.quiz_difficulty_Level = false;
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/QuizQuestionBank/difficultylevel")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.difficulty_level_list = res.data.difficulty_level_list;
                        this.load = true;
                    } else {
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {

                    "use strict";
                    var overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        editItem(item) {
            this.editedIndex = this.difficulty_level_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post(
                            "/QuizQuestionBank/editdifficultylevel",
                            this.editedItem
                        )
                        .then((res) => {
                            if (res.data.msg == "200") {
                                Object.assign(
                                    this.difficulty_level_list[this.editedIndex],
                                    this.editedItem
                                );
                                this.showSnackbar(
                                    "#4caf50",
                                    "Quiz Difficulty Level updated successfully..."
                                ); // show snackbar on success
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                            this.showSnackbar(
                                "#b71c1c",
                                "Something went wrong!!!"
                            );
                        })
                        .finally(() => {
                            this.addedItem.quiz_difficulty_Level = null
                        });

                    this.close();
                }
            } else {
                axios
                    .post("/QuizQuestionBank/savedifficultylevel", this.addedItem)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.difficulty_level_list.push(this.addedItem);
                            this.showSnackbar(
                                "#4caf50",
                                "Quiz Difficulty Level added successfully..."
                            ); // show snackbar on success
                            this.onLoad();
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar(
                                "#b71c1c",
                                res.data.snackbar_msg
                            ); // show snackbar on error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar(
                            "#b71c1c",
                            "Something went wrong!!!"
                        );
                    })
                    .finally(() => {
                        this.addedItem.quiz_difficulty_Level = null
                    });

                this.close();
            }
        }, // end of save()


        isValidated() {
            if (this.editedItem.quiz_difficulty_Level) {
                return true;
            } else {
                if (!this.editedItem.quiz_difficulty_Level) {
                    this.errorMsg.quiz_difficulty_Level = true;
                }

                return false;
            }
        }, // .....end of isValidated()
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}
</style>
